module.exports = __webpack_public_path__ + "static/media/yoga_land.99ddc39e.svg";